/*
 * @Date: 2022-07-04 09:34:54
 * @LastEditors: hanhuixian hanhuixian@lxrental.com
 */
import i18n from '@/i18n/index.js';

import { createRouter, createWebHistory } from 'vue-router'
import Nprogress from "nprogress";
import 'nprogress/nprogress.css'

import routes from './modules'
import rentGo from "@/tools/rentGo";


const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  // 滚动行为
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return {
        behavior: "smooth",
        savedPosition,
      }
    } else {
      const position = {}
      if (to.meta.hash) {
        position.selector = to.meta.hash
      } else {
        position.behavior = "smooth"
        position.top = 0
      }
      return position
    }
  
  },
})

// 全局前置路由守卫配置
router.beforeEach((to, from, next) => {
  Nprogress.start();

  next();
});

// 全局后置路由守卫配置
router.afterEach((to) => {
  if (to.meta.langKey) {
    //如果路由原信息配置了页面标题名称, 就重写页面标题
    document.title = i18n.global.t(to.meta.langKey);
  }
  Nprogress.done();
  // 页面浏览，数据埋点统计上报
  rentGo.pageView();
});

export default router
